export default __webpack_public_path__ + "static/media/linkedin_icon.db784f3e.png";